import Cookies from 'js-cookie'

const state = {
  sidebar: {
    opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
    withoutAnimation: false
  },
  smallSecretaryNotify: {
    needNotify: Cookies.get('smallSecretaryNotify') ? !!+Cookies.get('smallSecretaryNotify') : true
  },
  auditNotify: {
    needNotify: Cookies.get('auditNotify') ? !!+Cookies.get('auditNotify') : true
  },
  greetingAuditNotify: {
    needNotify: Cookies.get('greetingAuditNotify') ? !!+Cookies.get('greetingAuditNotify') : true
  },
  realPeopleAuditNotify: {
    needNotify: Cookies.get('realPeopleAuditNotify') ? !!+Cookies.get('realPeopleAuditNotify') : true
  },
  accusationAuditNotify: {
    needNotify: Cookies.get('accusationAuditNotify') ? !!+Cookies.get('accusationAuditNotify') : true
  },
  shortVideoAuditNotify: {
    needNotify: Cookies.get('shortVideoAuditNotify') ? !!+Cookies.get('shortVideoAuditNotify') : true
  },
  device: 'desktop'
}

const mutations = {
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened
    state.sidebar.withoutAnimation = false
    if (state.sidebar.opened) {
      Cookies.set('sidebarStatus', 1)
    } else {
      Cookies.set('sidebarStatus', 0)
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set('sidebarStatus', 0)
    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  },
  ADD_SMALL_SECRETARY_NOTIFY: state => {
    Cookies.set('smallSecretaryNotify', 1)
    state.smallSecretaryNotify.needNotify = true
  },
  CLEAR_SMALL_SECRETARY_NOTIFY: state => {
    Cookies.set('smallSecretaryNotify', 0)
    state.smallSecretaryNotify.needNotify = false
  },
  ADD_AIDIT_NOTIFY: state => {
    Cookies.set('auditNotify', 1)
    state.auditNotify.needNotify = true
  },
  CLEAR_AIDIT_NOTIFY: state => {
    Cookies.set('auditNotify', 0)
    state.auditNotify.needNotify = false
  },
  ADD_GREETING_AIDIT_NOTIFY: state => {
    Cookies.set('greetingAuditNotify', 1)
    state.greetingAuditNotify.needNotify = true
  },
  CLEAR_GREETING_AIDIT_NOTIFY: state => {
    Cookies.set('greetingAuditNotify', 0)
    state.greetingAuditNotify.needNotify = false
  },
  ADD_REAL_PEOPLE_AIDIT_NOTIFY: state => {
    Cookies.set('realPeopleAuditNotify', 1)
    state.realPeopleAuditNotify.needNotify = true
  },
  CLEAR_REAL_PEOPLE_AIDIT_NOTIFY: state => {
    Cookies.set('realPeopleAuditNotify', 0)
    state.realPeopleAuditNotify.needNotify = false
  },
  ADD_ACCUSATION_AIDIT_NOTIFY: state => {
    Cookies.set('accusationAuditNotify', 1)
    state.accusationAuditNotify.needNotify = true
  },
  CLEAR_ACCUSATION_AIDIT_NOTIFY: state => {
    Cookies.set('accusationAuditNotify', 0)
    state.accusationAuditNotify.needNotify = false
  },
  ADD_SHORT_VIDEO_AIDIT_NOTIFY: state => {
    Cookies.set('shortVideoAuditNotify', 1)
    state.shortVideoAuditNotify.needNotify = true
  },
  CLEAR_SHORT_VIDEO_AIDIT_NOTIFY: state => {
    Cookies.set('shortVideoAuditNotify', 0)
    state.shortVideoAuditNotify.needNotify = false
  }
}

const actions = {
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation)
  },
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device)
  },
  addAuditNotify({ commit }) {
    commit('ADD_AIDIT_NOTIFY')
  },
  clearAuditNotify({ commit }) {
    commit('CLEAR_AIDIT_NOTIFY')
  },
  addSmallSecretaryNotify({ commit }) {
    commit('ADD_SMALL_SECRETARY_NOTIFY')
  },
  clearSmallSecretaryNotify({ commit }) {
    commit('CLEAR_SMALL_SECRETARY_NOTIFY')
  },
  addGreetingAuditNotify({ commit }) {
    commit('ADD_GREETING_AIDIT_NOTIFY')
  },
  clearGreetingAuditNotify({ commit }) {
    commit('CLEAR_GREETING_AIDIT_NOTIFY')
  },
  addRealPeopleAuditNotifyNotify({ commit }) {
    commit('ADD_REAL_PEOPLE_AIDIT_NOTIFY')
  },
  clearRealPeopleAuditNotifyNotify({ commit }) {
    commit('CLEAR_REAL_PEOPLE_AIDIT_NOTIFY')
  },
  addAccusationAuditNotifyNotify({ commit }) {
    commit('ADD_ACCUSATION_AIDIT_NOTIFY')
  },
  clearAccusationAuditNotifyNotify({ commit }) {
    commit('CLEAR_ACCUSATION_AIDIT_NOTIFY')
  },
  addShortVideoAuditNotifyNotify({ commit }) {
    commit('ADD_SHORT_VIDEO_AIDIT_NOTIFY')
  },
  clearShortVideoAuditNotifyNotify({ commit }) {
    commit('CLEAR_SHORT_VIDEO_AIDIT_NOTIFY')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
